import {Response} from "@/hooks/services/queries/types";
import logger from "@FRAMEWORK/utils/logger";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

type GlobarBannerText = {
	adminTxtBnrSeq: number;
	bnrType: string;
	keyword: string;
	useYn: string;
	pcYn: string;
	pcUrl: string;
	pcNewWindowYn: string;
	mobileYn: string;
	mobileUrl: string;
	mobileNewWindowYn: string;
	bnrOrder: number;
	startDt: string;
	endDt: string;
	regId: number;
	regDt: string;
	updId: number;
	updDt: string;
};

type GlobarBannerTextParam = {
	bnrType: "KEYWORD";
	keyword: string;
};

/** ```
 * 공통 텍스트 배너조회 API
 *   `/global/banner/text/list`
 * parameter
 * 		bnrType: KEYWORD (공통코드: TXT_BNR_TYPE)
 *      keyword: string
 * ```*/
const key = "useGlobalBannerText";
const getPath = (): string | null => `/bff/global/bannerText`;

/** ```
 * 공통 텍스트 배너조회 API
 *   `/global/banner/text/list`
 * parameter
 * 		bnrType: KEYWORD (공통코드: TXT_BNR_TYPE)
 *      keyword: string
 * ```*/
const useGlobalBannerText = (
	params: GlobarBannerTextParam = {bnrType: "KEYWORD", keyword: ""},
	options?: Partial<UseQueryOptions<Response<GlobarBannerText[]>, Error>>,
) => {
	try {
		return useQuery({
			queryKey: [key, getPath()],
			queryFn: () => useConfigureAxios.get(getPath(), {params}).then(r => r.data),
			gcTime: Infinity,
			staleTime: Infinity,
			throwOnError: true,
			...options,
		});
	} catch (error) {
		logger.error(error);
	}
};

export default useGlobalBannerText;
export {getPath};
export type {GlobarBannerText};
